import { FC, HTMLAttributes, ReactNode, KeyboardEvent, MouseEvent } from 'react';
import { SlidingPane } from './SlidingPane';
import { SliderHeader } from './SliderHeader';
import { SliderNav } from './SliderNav';
import { SliderBody } from './SliderBody';
import { SliderFooter } from './SliderFooter';
import styles from './styles.module.scss';

export type SliderProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode; // typeof ( SliderHeader | SliderNav | SliderBody | SliderFooter )
  isOpen: boolean;
  onRequestClose: (event: MouseEvent | KeyboardEvent) => void;
  rootAppElement?: string;
  width?: string;
  overlayClassName?: string;
};

type SliderSubcomponents = {
  Header: typeof SliderHeader;
  Nav: typeof SliderNav;
  Body: typeof SliderBody;
  Footer: typeof SliderFooter;
};

export const Slider: FC<SliderProps> & SliderSubcomponents = ({
  children,
  isOpen,
  onRequestClose,
  rootAppElement = '#root',
  width = '820px',
  overlayClassName = '',
}) => (
  <SlidingPane
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    rootAppElement={rootAppElement}
    closeImmediately={false}
    width={width}
    overlayClassName={overlayClassName}
  >
    <div className={styles.slider}>{children}</div>
  </SlidingPane>
);

Slider.Header = SliderHeader;
Slider.Nav = SliderNav;
Slider.Body = SliderBody;
Slider.Footer = SliderFooter;
